/**
 * Orderable (commandable), Redirection, NotOrderable (non commandable)
 */
const orderabilityType = {
    ORDERABLE: 'orderable',
    REDIRECTION: 'redirection',
    NOTORDERABLE: 'notOrderable'
  }
export default orderabilityType;
